/**
 * Configuración de autenticación para Petflix API
 * 
 * Los tokens se obtienen desde variables de entorno (.env):
 * - REACT_APP_PETFLIX_ACCESS_TOKEN: Token de acceso principal
 * - REACT_APP_PETFLIX_ACCESS_TOKEN_WINNERS: Token específico para enviar ganadores
 * 
 * Si las variables de entorno no están definidas, el flujo falla cerrado.
 * Los tokens deben ser rotados/configurados por los responsables de secretos.
 */

export const petflixAuthConfig = {
  accessToken: process.env.REACT_APP_PETFLIX_ACCESS_TOKEN || '',
  accessToken_Winners: process.env.REACT_APP_PETFLIX_ACCESS_TOKEN_WINNERS || ''
};

/**
 * Obtiene el token de autenticación
 * Prioriza el token del localStorage (usuario logueado) sobre el token de configuración
 */
export function getPetflixAccessToken(): string | null {
  // Primero intentar obtener el token del localStorage (usuario logueado)
  try {
    const tokenFromStorage = localStorage.getItem('petflix_access_token');
    if (tokenFromStorage && tokenFromStorage.trim() !== '') {
      // Sincronizar el token de configuración con el del localStorage
      petflixAuthConfig.accessToken = tokenFromStorage;
      return tokenFromStorage;
    }
  } catch (e) {
    // Si hay error accediendo a localStorage, continuar con el token de configuración
    console.warn('Error accediendo a localStorage:', e);
  }
  
  // Si no hay token en localStorage, usar el token de configuración
  return petflixAuthConfig.accessToken || null;
}

/**
 * Actualiza el token de autenticación (solo en memoria durante la sesión)
 * Para persistir el token, edita la variable REACT_APP_PETFLIX_ACCESS_TOKEN en el archivo .env
 */
export function setPetflixAccessToken(token: string): void {
  petflixAuthConfig.accessToken = token;
}

/**
 * Obtiene el token de autenticación específico para enviar ganadores
 * Prioriza el token del localStorage (petflix_access_token_winners) sobre el token de configuración
 */
export function getPetflixAccessTokenWinners(): string | null {
  // Primero intentar obtener el token del localStorage
  try {
    const tokenFromStorage = localStorage.getItem('petflix_access_token_winners');
    if (tokenFromStorage && tokenFromStorage.trim() !== '') {
      return tokenFromStorage;
    }
  } catch (e) {
    // Si hay error accediendo a localStorage, continuar con el token de configuración
    console.warn('Error accediendo a localStorage:', e);
  }
  
  // Si no hay token en localStorage, usar el token de configuración
  return petflixAuthConfig.accessToken_Winners || null;
}

/**
 * Actualiza el token de autenticación para ganadores (solo en memoria durante la sesión)
 * Para persistir el token, edita la variable REACT_APP_PETFLIX_ACCESS_TOKEN_WINNERS en el archivo .env
 */
export function setPetflixAccessTokenWinners(token: string): void {
  petflixAuthConfig.accessToken_Winners = token;
}

